<template>
  <!-- Create/edit modal -->
  <div v-if="label" class="modal" :class="{ 'is-active': showModalIndex }">
    <div class="modal-background" @click="hideModal(true)"></div>
    <div class="modal-content">
      <div class="box">
        <h1 class="title">{{this.showCreationForm ? label.titles.encodeIndex : label.titles.editIndex}}</h1>
        <p>{{this.showCreationForm ? label.texts.indexEncodeInfo : label.texts.indexEditInfo}}</p>
        <br>

        <form @submit.prevent="submitMeteringForm">
          <div class="field">
            <label class="label">{{label.forms.date}}</label>
            <Datetime
              :disabled="!showCreationForm"
              v-model="meteringForm.date"
              input-class="input"
              auto format="dd-MM-yyyy"
              :min-datetime="minMeteringDate"
              :max-datetime="today"
              :phrases="{ok:label.buttons.ok, cancel:label.buttons.cancel}"
              value-zone="Europe/Brussels">
            </Datetime>
          </div>

          <label class="label">{{label.forms.registers}}</label>
          <div class="field has-addons" v-for="variable of registersToShowInForm" v-bind:key="variable.id">
            <template v-if="meteringForm.registersValues[variable.id] != null">
              <p class="control">
              <a class="button no-pointer">{{variable.name}}</a>
              </p>
              <p class="control">
                <input required type="number" class="input" min="0" step="0.1" v-model="meteringForm.registersValues[variable.id]" placeholder="0">
              </p>
              <p class="control">
                <a class="button is-static">{{pod.energy.inputUnit}}</a>
              </p>
            </template>
          </div>

          <div class="field is-grouped">
            <p class="control">
              <button class="button is-primary" type="submit">{{label.buttons.save}}</button>
            </p>
            <p class="control">
              <a class="button is-light" @click="hideModal(true)">{{label.buttons.cancel}}</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { MeteringService } from '../services';
import moment from 'moment';
import { Datetime } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { Settings } from 'luxon';

export default {
  components: {
    Datetime
  },
  props: ['openModal', 'showCreationForm', 'pod', 'reloadData', 'index', 'minMeteringDate', 'closeModal'],
  data() {
    return {
      meteringBeingEdited: null,
      meteringForm: {
        date: moment().local().startOf('day').toDate().toISOString(),
        registersValues: {}
      },
      showModalIndex: false
    }
  },
  computed: {
    ...mapState("account", ["user"]),
    ...mapState({ label: state => state.labels.indexes }),
    ...mapState({ locale: state => state.labels.locale }),
    registersToShowInForm() {
      if(this.pod && this.pod.variable) {
        if(this.showCreationForm) {
          let registersToShow = [];
          const onlyActiveRegisters = this.pod.variable.filter(v => !v.validTo)
          onlyActiveRegisters.forEach(v => {
            if(new Date(v.validFrom) <= new Date(this.meteringForm.date)) {
              registersToShow.push(v)
            }
          })
          return registersToShow
        }
        else {
          let registersToShow = [];
          this.pod.variable.forEach(v => {
            if(new Date(v.validFrom) <= new Date(this.meteringForm.date)) {
              registersToShow.push(v)
            }
          })
          return registersToShow
        }
      }
      else {
        return []
      }
    },
    today() {
      return moment().local().startOf('day').toDate().toISOString()
    }
  },
  methods: {
    ...mapActions("labels", ["getLabel"]),
    formatDate(date) {
      return moment(date).toDate().toISOString()
    },
    submitMeteringForm() {
      this.hideModal(false);
      // only save the registers with non null values (null values mean there should not be a value on the register because it's not active anymore)
      let registersToSubmit = []
      let inputValuesAsArray = []
      for(let variable of this.registersToShowInForm) {
        const registerValue = this.meteringForm.registersValues[variable.id]
        if(registerValue != null) {
          registersToSubmit.push(variable)
          inputValuesAsArray.push(this.meteringForm.registersValues[variable.id])
        }
      }
      if(this.showCreationForm) {
        MeteringService.addIndex(
          registersToSubmit.map(v => v.id),
          inputValuesAsArray,
          new Date(this.meteringForm.date),
          this.pod.energy.hasCumulativeIndexes ? 'index':'conso',
          "user",
          this.pod.id,
          this.user._id)
        .then((index) => {
          this.meteringForm.registersValues = {};
          this.showModalIndex = false
          this.reloadData('addIndex', index.date);
        })
      }
      else {
        MeteringService.modifyIndex(this.user._id, this.pod.id, this.meteringBeingEdited.transactionID, registersToSubmit.map(v => v.id), inputValuesAsArray, new Date(this.meteringForm.date))
        .then(() => {
          this.meteringForm.registersValues = {}
          this.showModalIndex = false
          this.reloadData('ModifyIndex', new Date(this.meteringForm.date))
        })
      }
    },
    createIndexModal() {
      this.meteringForm.date = moment().local().startOf('day').toDate().toISOString()

      for(let i in this.pod.variable) {
        this.meteringForm.registersValues[this.pod.variable[i].id] = 0;
      }

      this.showModalIndex = true
    },
    editIndexModal(index) {
      this.meteringForm.date = this.formatDate(index.date)

      for(let i in this.pod.variable) {
        let foundMetering = index.meterings.find(elem => elem.variable.id == this.pod.variable[i].id)
        this.meteringForm.registersValues[this.pod.variable[i].id] = foundMetering ? foundMetering.value : null;
      }
      this.meteringBeingEdited = {...index};

      this.showModalIndex = true
    },
    hideModal(isCancelled) {
      this.showModalIndex = false;
      this.closeModal(isCancelled)
    },
  },
  created() {
    this.getLabel({ view: 'indexes' });
    Settings.defaultLocale = this.locale;
  },
  watch: {
    openModal() {
      if (this.openModal) {
        if (this.showCreationForm)
          this.createIndexModal()
        else
          this.editIndexModal(this.index)
      }
    }
  }
}
</script>

<style>

</style>